<template>
  <section class="hero">
    <!-- 背景图 + 粒子网络 + 光斑 -->
    <div class="hero-bg">
      <img class="hero-img" :src="img('gen/hero-home.jpg')" alt="皓辰科技 产业数字化"/>
      <div class="hero-mask"></div>
      <TechCanvas class="hero-canvas"/>
      <div class="grid-bg"></div>
      <span class="orb orb-a"></span>
      <span class="orb orb-b"></span>
    </div>

    <div class="page hero-inner">
      <div class="hero-copy">
        <span class="eyebrow reveal" v-reveal>智慧农业 · 工业物联网 · 企业服务</span>

        <h1 class="h1 hero-title reveal" v-reveal="{ delay: 80 }">
          以物联网与数据智能<br/>
          <span class="grad-text">重塑产业现场的生产力</span>
        </h1>

        <p class="hero-lead reveal" v-reveal="{ delay: 160 }">
          海阳皓辰网络科技有限公司专注农业、工业与政企场景，提供从终端感知、边缘控制到平台应用的一体化解决方案，
          让数据在生产现场真正跑起来。
        </p>

        <div class="hero-actions reveal" v-reveal="{ delay: 240 }">
          <router-link to="/agriculture" class="btn btn-primary">
            查看四大业务线
            <IconSvg name="arrow-right"/>
          </router-link>
          <router-link to="/contact" class="btn btn-ghost">立即咨询方案</router-link>
        </div>

        <ul class="hero-facts reveal" v-reveal="{ delay: 320 }">
          <li v-for="f in facts" :key="f.key">
            <div class="fact-value">{{ f.value }}<em>{{ f.unit }}</em></div>
            <div class="fact-desc">{{ f.desc }}</div>
          </li>
        </ul>
      </div>
    </div>

    <router-link to="/home" class="scroll-hint" aria-label="向下滚动" @click.native.prevent="scrollDown">
      <span class="mouse"><i></i></span>
      <span class="scroll-text">向下了解更多</span>
      <IconSvg name="arrow-down"/>
    </router-link>
  </section>
</template>

<script>
import TechCanvas from '@/components/common/TechCanvas'
import IconSvg from '@/components/common/IconSvg'
import img from '@/utils/assets'
import { heroFacts } from '@/data/site'

export default {
  name: 'HeroSection',
  components: { TechCanvas, IconSvg },
  data() {
    return { facts: heroFacts, img }
  },
  methods: {
    scrollDown() {
      window.scrollTo({ top: window.innerHeight - 70, behavior: 'smooth' })
    }
  }
}
</script>

<style lang="scss" scoped>
.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  padding: calc(var(--nav-h) + 40px) 0 110px;
  overflow: hidden;
}

.hero-bg {
  position: absolute;
  inset: 0;

  .hero-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.55;
    transform: scale(1.04);
  }

  .hero-mask {
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse 70% 60% at 18% 42%, rgba(34, 224, 255, 0.16), transparent 68%),
      radial-gradient(ellipse 60% 50% at 86% 70%, rgba(139, 92, 246, 0.18), transparent 70%),
      linear-gradient(180deg, rgba(3, 7, 17, 0.86) 0%, rgba(3, 7, 17, 0.72) 42%, rgba(3, 7, 17, 0.98) 100%);
  }

  .hero-canvas { opacity: 0.85; }

  .orb-a {
    width: 460px; height: 460px; top: -120px; right: 6%;
    background: radial-gradient(closest-side, rgba(34, 224, 255, 0.55), transparent);
  }
  .orb-b {
    width: 520px; height: 520px; bottom: -180px; left: -60px;
    background: radial-gradient(closest-side, rgba(61, 123, 255, 0.5), transparent);
  }
}

.hero-inner { position: relative; z-index: 2; }
.hero-copy { max-width: 820px; }

.hero-title { margin-top: 22px; }

.hero-lead {
  margin-top: 26px;
  max-width: 660px;
  font-size: 17px;
  line-height: 1.95;
  color: var(--txt-2);
}

.hero-actions {
  display: flex;
  gap: 16px;
  margin-top: 38px;
  flex-wrap: wrap;
}

.hero-facts {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
  margin-top: 62px;
  max-width: 860px;

  li {
    position: relative;
    padding: 22px 24px;
    border-radius: 16px;
    border: 1px solid var(--line);
    background: linear-gradient(150deg, rgba(12, 26, 52, 0.78), rgba(6, 13, 29, 0.6));
    backdrop-filter: blur(10px);
    transition: transform 0.4s, border-color 0.4s;

    &:hover { transform: translateY(-4px); border-color: var(--line-strong); }
  }

  .fact-value {
    font-size: 26px;
    font-weight: 700;
    color: #fff;
    em { font-size: 13px; font-style: normal; margin-left: 6px; color: var(--cyan); }
  }

  .fact-desc { margin-top: 8px; font-size: 13.5px; color: var(--txt-3); }
}

.scroll-hint {
  position: absolute;
  left: 50%;
  bottom: 26px;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: var(--txt-3);
  font-size: 12px;
  letter-spacing: 0.16em;
  z-index: 3;
  transition: color 0.3s;

  &:hover { color: var(--cyan); }

  svg { width: 16px; height: 16px; animation: bounce 1.8s infinite; }

  .mouse {
    width: 22px;
    height: 34px;
    border: 1px solid var(--line-strong);
    border-radius: 12px;
    display: flex;
    justify-content: center;
    padding-top: 6px;

    i {
      width: 3px;
      height: 7px;
      border-radius: 3px;
      background: var(--cyan);
      animation: wheel 1.8s infinite;
    }
  }
}

@keyframes wheel {
  0% { transform: translateY(0); opacity: 1; }
  100% { transform: translateY(12px); opacity: 0; }
}

@keyframes bounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(5px); }
}

@media (max-width: 900px) {
  .hero { padding: calc(var(--nav-h) + 30px) 0 96px; min-height: auto; }
  .hero-lead { font-size: 15px; }
  .hero-facts { grid-template-columns: minmax(0, 1fr); gap: 12px; margin-top: 40px; }
  .scroll-hint { display: none; }
}
</style>
